
###
TODO:
	- Make a "filter" component that is just the markup, and consume it twice
	to make a desktop filter and a mobile filter
###
import DataBinding from './mixins/data-binding'

export default
	props: layout: String
	mixins: [DataBinding]

	computed:
		selectIcon: -> if @layout == "variation-one" then "chevron"

